import { useEffect, useRef } from 'react';

type SequenceItem = { productid: string, barcode: string };
type Callback = (sequenceItem: SequenceItem) => void;

const useKeySequence = (sequences: SequenceItem[], callback: Callback) => {
  const sequencesRef = useRef(sequences);
  const callbackRef = useRef(callback);

  useEffect(() => {
    sequencesRef.current = sequences;
    callbackRef.current = callback;
  }, [sequences, callback]);

  useEffect(() => {
    let inputSoFar = '';

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Enter') {
        inputSoFar += e.key;
        if (!sequencesRef.current.some(seq => seq.productid.startsWith(inputSoFar) || seq.barcode.startsWith(inputSoFar))) {
          inputSoFar = '';
        }
      } else {
        if (inputSoFar !== '') { // Added condition to prevent callback for empty input
          const foundItem = sequencesRef.current.find(seq => seq.productid === inputSoFar || seq.barcode === inputSoFar);
          if (foundItem) {
            callbackRef.current(foundItem);
          }
          inputSoFar = '';
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
};

export default useKeySequence;
